export default function AptitudeLoadingGaugeDirective($log) {
  'use strict';

  return {
    restrict: 'A',
    scope: {
      isLoaded: '=',
      percentage: '='
    },
    template: '<div style="width: 150px; height: 150px; margin: 0 auto"></div>',
    replace: true,
    controller: function ($scope, $element) {
      'ngInject';

      function getLoadPercentage(percentage) {
        if (percentage === 0) {
          // If the values are anything other than 0 and 100 or 100 and 0 then everything works.
          percentage = 1;
        } else if (percentage === 100) {
          // Same as above, don't ever let the percentage go to 100%
          percentage = 99;
        }

        if (percentage == 99) {
          $scope.isLoaded = true;
        }

        var newData = [
          {
            name: 'loaded',
            color: '#8dc34b',
            y: percentage
          },
          {
            name: 'not',
            color: '#d3d3d3',
            y: 100 - percentage
          }
        ];

        return newData;
      }

      $element.highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: 'the title',
        tooltip: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false
            },
            borderWidth: 0,
            startAngle: -180,
            endAngle: 180,
            center: ['50%', '50%']
          }
        },
        series: [
          {
            type: 'pie',
            name: '',
            innerSize: '90%',
            ignoreHiddenPoint: true,
            data: getLoadPercentage($scope.percentage)
          }
        ]
      });

      $scope.$watch('percentage', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          var seriesData = $element.highcharts().series[0];
          var data = getLoadPercentage($scope.percentage);
          seriesData.setData(data);
        }
      });
    }
  };
}
